import { Condition } from './Condition';

/**
 * The Expand class
 */
export class Expand {
  /**
   * The property to expand
   */
  public ExpandProperty: string;

  /**
   * The fields
   */
  public Fields: string[];

  /**
   * The expansions
   */
  public Expands: Expand[];

  /**
   * Create a new Filter
   * @param fieldName The field name
   */
  constructor(expandProperty: string, fields: string[] = [], expands: Expand[] = []) {
    this.ExpandProperty = expandProperty;
    this.Fields = fields;
    this.Expands = expands;
  }

  public ToDataQuery() {
    let query: string = "";

    query += this.ExpandProperty;

    let clauses: string[] = [];
    if (this.Fields.length > 0) { clauses.push(`$select=${this.Fields.join(",")}`); }
    if (this.Expands.length > 0) {
      let expands: string[] = [];
      for (let expand of this.Expands) {
        expands.push(expand.ToDataQuery());
      }
      clauses.push(`$expand=${expands.join(",")}`);
    }

    if (clauses.length > 0) {
      query += `(${clauses.join("&")})`;
    }

    return query;
  }
}